import React, { memo, useCallback } from 'react'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

export type DeleteCommentModalResult = 'cancel' | 'delete'

function DeleteCommentModal() {
  const modalElement = useModalElementContext<DeleteCommentModalResult>()

  const handlePrimaryClick = useCallback(() => {
    modalElement.resolve('delete')
  }, [modalElement])

  const handleSecondaryClick = useCallback(() => {
    modalElement.resolve('cancel')
  }, [modalElement])

  return (
    <Modal
      title="Delete this comment?"
      primaryActionText="Delete"
      secondaryActionText="Cancel"
      onPrimaryActionClick={handlePrimaryClick}
      onSecondaryActionClick={handleSecondaryClick}
    >
      <BodyText variant="large">
        Deleting this comment will remove it for all users. This action cannot be undone.
      </BodyText>
    </Modal>
  )
}

export default memo(DeleteCommentModal)
